import {Component, OnDestroy, OnInit} from '@angular/core';
import {NotificationService} from '../../../../core/services/notification.service';
import {ConfigService} from '../../../../core/services/config.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AccountConfigurationService} from '../account-configuration.service';
import {Observable, Subscription} from 'rxjs';

@Component({
    selector: 'itpx-account-configurations-details',
    templateUrl: './account-configurations-details.component.html',
    styleUrls: [ './account-configurations-details.component.css' ]
})

export class AccountConfigurationsDetailsComponent implements OnInit, OnDestroy {

    private id: any;
    private details: any = null;
    private dtoToDelete: any = null;
    private domains: any;
    private groups: any;
    private allSubscriptions: Array<Subscription> = [];
    private isInProgress: boolean = false;

    private buttons: Array<any> = [
        {
            title: 'Edit',
            action: 'edit',
            icon: 'fa-pencil-square',
            class: 'btn-primary',
            disabled: false
        },
        {
            title: 'Delete',
            action: 'delete',
            icon: 'fa-trash',
            class: 'btn-danger',
            disabled: false
        }
    ];

    constructor(
        private notificationService: NotificationService,
        private configService: ConfigService,
        private router: Router,
        private route: ActivatedRoute,
        private accountConfigurationService: AccountConfigurationService
    ) { }

    ngOnInit(): void {
        this.isInProgress = true;
        this.fetchGroupsAndDomains();
    }

    fetchGroupsAndDomains() {
        this.allSubscriptions.push(
            Observable.combineLatest([
                this.accountConfigurationService.getDomains(),
                this.accountConfigurationService.getGroups()
            ]).subscribe(([domains, groups]) => {
                this.domains = domains;
                this.groups = groups;
                this.fetchDetails();
            })
        );
    }

    fetchDetails() {
        this.allSubscriptions.push(
            this.route.params.subscribe(params => {
                this.id = params['id'];
                this.accountConfigurationService.getDetails(this.id).map(_ => _.data)
                    .subscribe(_ => {
                        this.dtoToDelete = _;
                        this.details = {
                            ..._,
                            group : _.group.configValue + ', ' + _.group.configType + ', ' + _.group.configKey
                        };
                        this.isInProgress = false;
                    });
            })
        );
    }

    get fields() {
        return [
            {
                key: 'configKey',
                label: 'Key',
                type: 'text'
            }, {
                key: 'configValue',
                label: 'Value',
                type: 'text'
            },
            {
                key: 'defaultValue',
                label: 'Default Value',
                type: 'text'
            },{
                key: 'group',
                label: 'Group',
                type: 'text'
            },
            {
                key: 'domain',
                label: 'Domain',
                type: 'text'
            },
        ];
    }

    private onAction(action: string) {
        this.isInProgress = true;
        if (action == 'edit') {
            this.router.navigate(['/agora/account-configurations/:id/edit', { id: this.id }]);
        } else if (action == 'delete') {
            this.allSubscriptions.push(
                this.accountConfigurationService.deleteAccountConfig(this.dtoToDelete).subscribe(
                    _ => {
                        this.isInProgress = false;
                        this.notificationService.success('Successfully deleted configuration');
                        this.router.navigate(['/agora/account-configurations']);
                    }
                )
            );

        } else {
            return false;
        }
    }

    ngOnDestroy(): void {
        this.allSubscriptions.map(_ => _.unsubscribe());
    }
}



// WEBPACK FOOTER //
// ./src/app/agora/components/account-configurations/details/account-configurations-details.component.ts